// extracted by mini-css-extract-plugin
module.exports = {"container":"AreaSelect__container__lnal4"};